import React from 'react';
import Icon from '@/shared/components/Icon';
import clsx from 'clsx';

import {formatCatalogPrice, type CatalogTestDisplay} from './catalogUtils';

interface CatalogTestDotRowProps {
    test: CatalogTestDisplay;
    /** Show gray "—" instead of price (test belongs to a bundled panel). */
    includedInBundledPanel?: boolean;
    /** Admin: show AlertTriangle icon for $0 prices. */
    showAlertIcon?: boolean;
    className?: string;
}

const CatalogTestDotRow: React.FC<CatalogTestDotRowProps> = ({
    test,
    includedInBundledPanel = false,
    showAlertIcon = false,
    className,
}) => (
    <div
        className={clsx(
            'flex items-center gap-2 px-3 py-1',
            (!test.inAssayCatalog || test.isMissingPrerequisite) && 'opacity-40',
            className,
        )}>
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-mld-primary" />
        <span className="text-xs text-gray-700">{test.name}</span>
        {test.isMissingPrerequisite && (
            <span className="text-[10px] font-medium text-mld-danger">(missing prerequisite)</span>
        )}
        {!test.isMissingPrerequisite && !test.inAssayCatalog && (
            <span className="text-[10px] font-medium text-mld-danger">(no catalog match)</span>
        )}
        <span
            className={clsx(
                'ml-auto font-mono text-xs',
                includedInBundledPanel ? 'text-gray-400' : 'text-mld-primary',
            )}>
            {includedInBundledPanel ? (
                '—'
            ) : test.isCalculated ? (
                <span className="font-semibold text-mld-success">Free</span>
            ) : showAlertIcon && test.addonPrice === 0 ? (
                <span className="inline-flex items-center gap-1 text-mld-danger" title="Price is $0.00 — needs to be set">
                    <Icon name="triangle-exclamation" className="h-3 w-3" />
                    $0.00
                </span>
            ) : (
                formatCatalogPrice(test.addonPrice)
            )}
        </span>
    </div>
);

export {CatalogTestDotRow};
